import { useEffect, useMemo, useState } from "react"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import { Input } from "../../../components/ui/input"
import { RoundedButton } from "../../../components/ui/roundButton"

const toApiPayload = ({ name, description }) => ({
  name: name?.trim(),
  description: description?.trim(),
})

const validateFields = ({ name, description }) => {
  const errors = []

  if (!name?.trim()) {
    errors.push("Nome não pode ser vazio.")
  }

  if (!description?.trim()) {
    errors.push("Descrição não pode ser vazia.")
  }

  return errors
}

const ProductsModal = ({
  open,
  onClose,
  onSubmit,
  initialValue,
  submitLabel = "Salvar",
}) => {
  const [name, setName] = useState(initialValue?.name || "")
  const [description, setDescription] = useState(initialValue?.description || "")

  useEffect(() => {
    if (!open) return

    setName(initialValue?.name || "")
    setDescription(initialValue?.description || "")
  }, [open, initialValue])

  const errors = useMemo(() => validateFields({ name, description }), [name, description])

  const handleSubmit = () => {
    if (errors.length > 0) return

    onSubmit({
      ...initialValue,
      ...toApiPayload({ name, description }),
    })
  }

  return (
    <DefaultModal
      open={open}
      handleClose={onClose}
      title="Produto ou serviço"
      maxWidth="xs"
      action={
        <div style={{ display: "flex", gap: 12 }}>
          <RoundedButton rounded="outlined" onClick={onClose} sx={{ flex: 1 }}>
            Cancelar
          </RoundedButton>
          <RoundedButton onClick={handleSubmit} disabled={errors.length > 0} sx={{ flex: 1 }}>
            {submitLabel}
          </RoundedButton>
        </div>
      }
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Nome</span>
          <Input
            value={name}
            onChange={({ target }) => setName(target.value)}
            placeholder="Informe o nome do produto ou serviço"
          />
        </label>

        <label className="space-y-1.5">
          <span className="block text-sm font-semibold text-gray-600">Descrição</span>
          <textarea
            value={description}
            onChange={({ target }) => setDescription(target.value)}
            placeholder="Descreva o produto ou serviço"
            rows={4}
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-base outline-none placeholder:text-muted-foreground"
          />
        </label>
      </div>
    </DefaultModal>
  )
}

export default ProductsModal
